
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/poke-the-bear/faq",
      function () {
        return require("private-next-pages/poke-the-bear/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/poke-the-bear/faq"])
      });
    }
  